import type { AssetDto } from '@/api/WhisApi/generated';
import { FoldableSection } from '@/components/FoldableSection/FoldableSection';
import { useAppTranslation } from '@/hooks/useAppTranslation';
import type { ReactElement } from 'react';
import { SizableText, YStack } from 'tamagui';
import { ReportDetailSection } from '../ReportDetailSection';
import { AssetPreviewModal } from './components/AssetPreviewModal';
import { SupportingDocumentRow } from './components/SupportingDocumentRow';
import { useAssetPreview } from './useAssetPreview';

interface ReportDetailSupportingDocumentsProps {
  assets: AssetDto[];
  defaultOpen?: boolean;
}

export const ReportDetailSupportingDocuments = ({
  assets,
  defaultOpen = false,
}: ReportDetailSupportingDocumentsProps): ReactElement => {
  const { t } = useAppTranslation();
  const { previewUrl, previewName, openPreview, closePreview } =
    useAssetPreview();

  return (
    <ReportDetailSection>
      <FoldableSection
        title={t('reportDetail.sections.supportingDocuments')}
        defaultOpen={defaultOpen}
      >
        <YStack gap="$4">
          {assets.length === 0 ? (
            <SizableText size="$2" color="$secondary50">
              {t('reportDetail.supportingDocuments.empty')}
            </SizableText>
          ) : (
            assets.map((asset) => {
              return (
                <SupportingDocumentRow
                  key={asset.id}
                  asset={asset}
                  onPreviewImage={openPreview}
                />
              );
            })
          )}
        </YStack>
      </FoldableSection>
      <AssetPreviewModal
        previewUrl={previewUrl}
        previewName={previewName}
        onClose={closePreview}
      />
    </ReportDetailSection>
  );
};
